import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions('mobileWrapperTasks', [
            'setTask',
            'getAndRemoveTask',
        ]),
    },
}
